import { Id, InternalPicturePath } from "../types.type";
import { TeamNamesEnum } from "../enums/team-names.enum";
import { SocialInterface } from "../interfaces/social.interface";
import { MapInformationInterface } from "../interfaces/map-information.interface";
import { ContentInterface } from "../interfaces/content.interface";
import { CountryClass } from "./country.class";
import { CountryCodes } from "../enums/country-codes.enum";
import { PartnerInterface } from "../interfaces/partner.interface";

export class Partner implements PartnerInterface {
    public country: CountryClass;

    constructor(
        public id: Id,
        public excluded: boolean, // in case of a Fake Partner that should not appear in View
        public name: string,
        public organisation: string,
        public imageUrlPublic: InternalPicturePath,
        public team: TeamNamesEnum,
        public social: SocialInterface,
        public mapInformation: MapInformationInterface,
        public content: ContentInterface,
        public countryCode: CountryCodes,
        public bgImageForCard: InternalPicturePath,
        public negativeImage: InternalPicturePath,
    ) {
        this.country = new CountryClass(countryCode)
    }


}
